/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/feedback.config.json';
import { useProductQR } from '../provider';
import axios from 'axios';
import { toast } from 'react-hot-toast';

export interface IFeedbackMethods extends IPluginMethodMap {
  onFeedbackSubmit(args: any): Promise<any>;
}

export class FeedbackService implements IAgentPlugin {
  readonly methods: IFeedbackMethods;

  constructor() {
    this.methods = {
      onFeedbackSubmit: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const id = useProductQR();
    console.log(`In service args: `, args, id);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.feedbackEP}`,
        {
          ...args?.variables,
        },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      if (res?.data) {
        return res?.data?.data;
      }
    } catch (err: any) {
      console.log(`error in service :`, err);
      //toast.error(err?.response?.data?.error_message, { duration: 3000 });
      return false;
    }
  }
}
